export default "__VITE_ASSET__DNe3n7je__"